import { render } from "./ContactCard.vue?vue&type=template&id=fcb45f72"
import script from "./ContactCard.vue?vue&type=script&lang=js"
export * from "./ContactCard.vue?vue&type=script&lang=js"

import "./ContactCard.vue?vue&type=style&index=0&id=fcb45f72&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__